import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../AssetUrlTheme';

export type SectionType = 'prefix' | 'kind' | 'signature' | 'transformation' | 'version' | 'publicId' | 'ellipsis';

export interface SectionProps {
  /** Text of the `Section` */
  children?: ReactNode;
  collapsible?: boolean;
  /** Function to call on click */
  onClick?: () => void;
}

export interface BaseSectionProps extends SectionProps {
  /** Type of section we want to create */
  type: SectionType;
}

const Root = styled.span<Omit<BaseSectionProps, 'children'>>`
  font-family: Consolas, monaco, monospace;
  color: ${({ type }) => theme.section[type]};
  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `}
`;

export const Section: FC<React.PropsWithChildren<BaseSectionProps>> = ({ children, type, collapsible, onClick }) => (
  <Root type={type} collapsible={collapsible} onClick={onClick}>
    {children}
  </Root>
);

export default Section;
